import BSCLOGO from '@/assets/imgs/chain/bnb-logo.png'
import FSCLOGO from '@/assets/imgs/chain/fsc-logo.png'
import ETHLOGO from '@/assets/imgs/chain/eth-logo.png'
import POLYGONLOGO from '@/assets/imgs/chain/polygon-logo.png'
import TRONLOGO from '@/assets/imgs/chain/tron-logo.png'
export const buildTxUrl = (chain, trx_id) => {
  return chain.chainId == 95500? `${chain.explorer}/#/transaction/${trx_id.substr(2).toLowerCase()}`: `${chain.explorer}/tx/${trx_id}`
}
export const buildAddrUrl = (chain, addr) => {
  return chain.chainId == 95500? `${chain.explorer}/#/address/${addr}`: `${chain.explorer}/address/${addr}`
}
const exchangeContract = "0xda98Aa8a2624702AA79174D685baDdA036D041D0"
const exchangeAccount = "0x3973bC3391Cc77C30D3303A023c1B58fCBb9e7e2" // TFCzAQvnYvKup52Ft2Tav6Q1JuX8QbAeBA
const ankrKey = "11708299164b65a1779d47a407d0e4ca70e558e6f4a447156147ca50cfbbd376"

export const Chains = {
  bsc: {
    chainId: 56,
    explorer: 'https://bscscan.com',
    logo: BSCLOGO,
    contract: '0x519a5bD234e88ccf41C87d9730122E5C82F2214E',
    usdt: '0x55d398326f99059ff775485246999027b3197955',
    ausdt: '0xa9251ca9DE909CB71783723713B21E4233fbf1B1',
    usdtDecimals: 18,
    name: 'BNB Chain',
    coin: 'BNB',
    rpc: 'https://rpc.ankr.com/bsc/'+ ankrKey,
    gasFee: 0.15, // usdt
    feeRate: 0.3, // 0.3%
    gasPrice: 'floating',
    gasPriceFloor: 0.10, // follow BSC recommended minimum (gwei)
    gasPriceBump: 1.10, // modest bump to improve inclusion without overpaying
    gasPriceRetryFloor: 0.30, // emergency retry floor when node rejects low gas as underpriced
    gasFeeForNaive: 0.00033, // gas used 110000 * gasPrice 3000000000
    exchangeAccount,
    exchangeContract,
  },
  fsc: {
    chainId: 201022,
    explorer: 'https://fonscan.io',
    logo: FSCLOGO,
    contract: '0x055c89F69Cd06c02388a3B12cA385439De847D7B',
    usdt: '0x9a9eD7440a3850c4D7240c9FcA8B7C96802615f0',
    usdtDecimals: 18,
    name: 'FON Chain',
    coin: 'FON',
    rpc: 'https://fsc-dataseed2.fonscan.io',
    gasFee: 0, // usdt
    feeRate: 0, // 0.3%
    withdraw: '0x8971A707c958e1EaE4147FF0318117049f50c6d2',
    gasPrice: 200,
    gasPriceBump: 1.05,
    gasFeeForNaive: 0.0055,
    exchangeAccount,
    exchangeContract,
  },
  eth: {
    chainId: 1,
    explorer: 'https://etherscan.io',
    logo: ETHLOGO,
    contract: '0xAb2A5E0D11906AC1Ca2b3dEa904Cb3de306E0F57',
    usdt: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    usdtDecimals: 6,
    name: 'Ethereum',
    coin: 'ETH',
    rpc: 'https://rpc.ankr.com/eth/'+ ankrKey,
    gasFee: 'floating', // 浮动gas费用
    nativePrice: '1700',
    feeRate: 0.3, // 0.4%
    gasPrice: 'floating',
    gasPriceBump: 1.10,
    exchangeAccount,
    exchangeContract,
  },
  polygon: {
    chainId: 137,
    explorer: 'https://polygonscan.com',
    logo: POLYGONLOGO,
    contract: '0xb024bb315A1a04b9663Ba7d67A5351D7B2943A57',
    usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    usdtDecimals: 6,
    name: 'Polygon',
    coin: 'POL',
    rpc: 'https://rpc.ankr.com/polygon/'+ ankrKey,
    rpc: 'https://polygon-bor-rpc.publicnode.com',
    gasFee: 'floating', // 浮动gas费用
    nativePrice: '1.5',
    feeRate: 0.3, // 0.3%
    gasPrice: 'floating',
    gasPriceBump: 1.10,
    exchangeAccount,
    exchangeContract,
  },
  // okc: {
  //   chainId: 66,
  //   explorer: 'https://www.oklink.com/en/okc',
  //   logo: OKCLOGO,
  //   contract: '0xF17bA42F4d74528551FD590b71F252A124dE80C2',
  //   usdt: '0x382bb369d343125bfb2117af9c149795c6c65c50',
  //   usdtDecimals: 18,
  //   name: 'OKX Chain',
  //   coin: 'OKT',
  //   rpc: 'https://exchainrpc.okex.org',
  //   gasFee: 4, // usdt
  //   feeRate: 0.3, // 0.3%
  //   gasPrice: 1000,
  //   gasFeeForNaive: 0.11,
  //   exchangeAccount,
  //   exchangeContract: '0x0a903c103E89030483AAA0B16253F378e9E54c00',
  // },
  // heco: {
  //   chainId: 128,
  //   explorer: 'https://www.hecoinfo.com/en-us',
  //   logo: HECOLOGO,
  //   contract: '0x0540aFd2D9cF059dbd66c4b416aA18609dC6a09A',
  //   usdt: '0xa71edc38d189767582c38a3145b5873052c3e47a',
  //   usdtDecimals: 18,
  //   name: 'HECO',
  //   coin: 'HT',
  //   rpc: 'https://http-mainnet.hecochain.com',
  //   gasFee: 0.15, // usdt
  //   feeRate: 0.3, // 0.3%
  //   gasPrice: 3,
  //   gasFeeForNaive: 0.00033,
  //   exchangeAccount,
  //   exchangeContract,
  // },
  tron: {
    chainId: 95500,
    explorer: 'https://tronscan.org',
    logo: TRONLOGO,
    contract: '0xb822dfc2918bdffb5bdf9c0dac7f91e2c4db7d26', // TSkq7SwpgNt7jHtRtCZVVAfVMnEhzezMRL'
    usdt: '0xa614f803b6fd780986a42c78ec9c7f77e6ded13c', // TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t
    usdtDecimals: 6,
    name: 'TRON',
    coin: 'TRX',
    rpc: 'https://rpc.ankr.com/tron_jsonrpc/1df55e6f111be1e1faadd5c4d0c05b16d5220e2c68a23607c196f26d45d7f7b9',
    gasFee: 6, // usdt
    feeRate: 0.5, // 0.5%
    gasFeeForNaive: 38,
    exchangeAccount,
    exchangeContract: "0xeddce7d6ad167d93b95d43dd04b3aaa19746eb42", // TXeunKBfJmKVhpbzB6r2xY6CvuwkeHCWG1
  },
}

const ChainNames = Object.keys(Chains)

export const ChainContracts = ChainNames.map(chain => Chains[chain].usdt.toLowerCase())

export const ChainFromId = {
  [1]: 'eth',
  [56]: 'bsc',
  // [66]: 'okc',
  // [128]: 'heco',
  [137]: 'polygon',
  [201022]: 'fsc',
  [95500]: 'tron',
}

export function getChainFromId(chainId){
  return Chains[ChainFromId[chainId]]
}

/** EIP-3081 `wallet_addEthereumChain` 参数；TRON 等非 EVM 返回 null */
export function buildWalletAddEthereumChainParams(chainId) {
  const c = getChainFromId(chainId)
  if (!c || c.chainId == null) return null
  const id = Number(c.chainId)
  if (id === 95500) return null
  const hexId = '0x' + id.toString(16)
  const sym = String(c.coin || 'ETH').trim().slice(0, 11) || 'ETH'
  const rpc = c.rpc ? String(c.rpc).trim() : ''
  if (!rpc) return null
  return {
    chainId: hexId,
    chainName: String(c.name || `Chain ${id}`).slice(0, 64),
    nativeCurrency: {
      name: sym,
      symbol: sym,
      decimals: 18,
    },
    rpcUrls: [rpc],
    blockExplorerUrls: c.explorer ? [String(c.explorer)] : [],
  }
}

/** 兑换/进度/选链等 UI 用固定简称，避免全称在窄位被裁切 */
export function chainUiTicker(chain) {
  if (!chain || chain.chainId == null) return '--'
  const id = Number(chain.chainId)
  if (id === 56) return 'BSC'
  if (id === 201022) return 'FSC'
  if (id === 1) return 'ETH'
  if (id === 137) return 'POL'
  if (id === 95500) return 'TRON'
  const n = String(chain.name || '').toLowerCase()
  if (n.includes('bnb') || n.includes('bsc')) return 'BSC'
  if (n.includes('fon') || n.includes('fsc')) return 'FSC'
  if (n.includes('ethereum') || n === 'eth') return 'ETH'
  if (n.includes('polygon') || n.includes('matic')) return 'POL'
  if (n.includes('tron')) return 'TRON'
  const coin = String(chain.coin || '').toUpperCase()
  if (coin && coin.length <= 5) return coin
  if (coin) return coin.slice(0, 4)
  return '--'
}

export const AmountOpt = {
  min: 30, // 最小30U
  max: 100000, // 最大 10W U
  maxFee: 1000, // 最大手续费 1000U
}